// istanbul ignore file

import { navigate } from '@reach/router';

// By default we add base tag with https://cloudinary value which adds to all relative links
// that prefix. In development mode we need to navigate with localhost domain so links needs to be absolute
// Sometimes that application can be used on another local port so try to retrieve url from window location
const developmentPublicPath =
  process.env.NODE_ENV === 'development' && typeof window !== 'undefined' ? window.location.origin : process.env.DEVELOPMENT_PUBLIC_PATH;

export const navigateToPage = (pageUrl: string) => {
  const path = developmentPublicPath ? `${developmentPublicPath}${pageUrl}` : pageUrl;
  void navigate(path);
};
